// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../../../../assets/close.svg", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.addClient{
    background-color: #f9f9f6;
    width: 100%;
    height: 100%;
    padding-top: 43px;
    padding-left: 30px;
    padding-right: 56px;
    padding-bottom: 30px;
}

.addClient_header{
    display: flex;
    justify-content: space-between;
    margin-left: 44px;
    margin-bottom: 28px;
}

.addClient_headerTitle{
    font-weight: 400;
    font-size: calc(14px * var(--fontScaler));
    line-height: 19px;
    color: #8E9ABB;
}

.addClient_head_text{
    font-weight: 400;
    font-size: calc(12px * var(--fontScaler));
    line-height: 16px;
    color: #757575;
    padding-bottom: 28px;
    margin-left: 44px;
}

.addClient_form{
    background: #FFFFFF;
    box-shadow: 0px 4px 31.4423px rgba(202, 196, 208, 0.15);
    border-radius: 24px;
    padding: 28px;
    height: 100%;
    display: flex;
    flex-direction: column;
}

.addClient_scrollWrap{
    display: flex;
    flex-direction: column;
    overflow-y: auto;
    flex-grow: 1;
}

.addClient_inputs{
    display: flex;
    flex-wrap: wrap;
    --formGap: 10px;
    gap: 0px var(--formGap);
    align-items: flex-end;
}

.addClient_schedule{
    width: 100%;
}

.addClient_schedule_label{
    font-weight: 400;
    font-size: calc(12px * var(--fontScaler));
    line-height: 150%;

    color: #3B4256;
    margin-bottom: 16px;
}

.addClient_schedule_content{
    display: flex;
    gap: 21px;
    flex-wrap: wrap;
}

.addClient_firstName{
    width: calc(40% - var(--formGap) / 2);
}

.addClient_lastName{
    width: calc(60% - var(--formGap) / 2);
}

.addClient_dateOfBirth{
    width: calc(65% - var(--formGap) / 2);
    display: flex;
    gap: var(--formGap);

    align-items: flex-end;
}

.addClient_email{
    width: calc(35% - var(--formGap) / 2);
}

.addClient_notes{
    width: 100%;
    margin-top: 10px;
}

.addClient_buttons{
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-top: 20px;
}

.addClient_buttons_right{
    display: flex;
    gap: 26px;
}

.addClient_save{
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 10px 40px;
    background: #FFA825;
    border-radius: 24px;
    font-weight: 500;
    font-size: calc(13px * var(--fontScaler));
    line-height: 23px;
    text-align: center;
    text-transform: uppercase;
    color: #FFFFFF;
}

.addClient_delete{
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 10px 40px;
    background: #E23424;
    border-radius: 24px;
    font-weight: 500;
    font-size: calc(13px * var(--fontScaler));
    line-height: 23px;
    text-align: center;
    text-transform: uppercase;
    color: #FFFFFF;
}

.addClient_icon{
    width: 22px;
    height: 22px;
    border: none;
    background-repeat: no-repeat;
    background-position: center;
    background-size: contain;
}

.addClient_close_icon{
    width: 17px;
    height: 17px;
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
}

.dropDownCalendar_labelBox{
    width: 100%;
    margin-bottom: 14px;
}

.dropDownCalendar_dropDown{
    width: 100%;
}`, "",{"version":3,"sources":["webpack://./src/pages/dashboardPage/components/addClient/AddClient.css"],"names":[],"mappings":"AAAA;IACI,yBAAyB;IACzB,WAAW;IACX,YAAY;IACZ,iBAAiB;IACjB,kBAAkB;IAClB,mBAAmB;IACnB,oBAAoB;AACxB;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,iBAAiB;IACjB,mBAAmB;AACvB;;AAEA;IACI,gBAAgB;IAChB,yCAAyC;IACzC,iBAAiB;IACjB,cAAc;AAClB;;AAEA;IACI,gBAAgB;IAChB,yCAAyC;IACzC,iBAAiB;IACjB,cAAc;IACd,oBAAoB;IACpB,iBAAiB;AACrB;;AAEA;IACI,mBAAmB;IACnB,uDAAuD;IACvD,mBAAmB;IACnB,aAAa;IACb,YAAY;IACZ,aAAa;IACb,sBAAsB;AAC1B;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,gBAAgB;IAChB,YAAY;AAChB;;AAEA;IACI,aAAa;IACb,eAAe;IACf,eAAe;IACf,uBAAuB;IACvB,qBAAqB;AACzB;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,gBAAgB;IAChB,yCAAyC;IACzC,iBAAiB;;IAEjB,cAAc;IACd,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,SAAS;IACT,eAAe;AACnB;;AAEA;IACI,qCAAqC;AACzC;;AAEA;IACI,qCAAqC;AACzC;;AAEA;IACI,qCAAqC;IACrC,aAAa;IACb,mBAAmB;;IAEnB,qBAAqB;AACzB;;AAEA;IACI,qCAAqC;AACzC;;AAEA;IACI,WAAW;IACX,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,SAAS;AACb;;AAEA;IACI,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,kBAAkB;IAClB,mBAAmB;IACnB,mBAAmB;IACnB,gBAAgB;IAChB,yCAAyC;IACzC,iBAAiB;IACjB,kBAAkB;IAClB,yBAAyB;IACzB,cAAc;AAClB;;AAEA;IACI,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,kBAAkB;IAClB,mBAAmB;IACnB,mBAAmB;IACnB,gBAAgB;IAChB,yCAAyC;IACzC,iBAAiB;IACjB,kBAAkB;IAClB,yBAAyB;IACzB,cAAc;AAClB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,YAAY;IACZ,4BAA4B;IAC5B,2BAA2B;IAC3B,wBAAwB;AAC5B;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,yDAAqD;AACzD;;AAEA;IACI,WAAW;IACX,mBAAmB;AACvB;;AAEA;IACI,WAAW;AACf","sourcesContent":[".addClient{\n    background-color: #f9f9f6;\n    width: 100%;\n    height: 100%;\n    padding-top: 43px;\n    padding-left: 30px;\n    padding-right: 56px;\n    padding-bottom: 30px;\n}\n\n.addClient_header{\n    display: flex;\n    justify-content: space-between;\n    margin-left: 44px;\n    margin-bottom: 28px;\n}\n\n.addClient_headerTitle{\n    font-weight: 400;\n    font-size: calc(14px * var(--fontScaler));\n    line-height: 19px;\n    color: #8E9ABB;\n}\n\n.addClient_head_text{\n    font-weight: 400;\n    font-size: calc(12px * var(--fontScaler));\n    line-height: 16px;\n    color: #757575;\n    padding-bottom: 28px;\n    margin-left: 44px;\n}\n\n.addClient_form{\n    background: #FFFFFF;\n    box-shadow: 0px 4px 31.4423px rgba(202, 196, 208, 0.15);\n    border-radius: 24px;\n    padding: 28px;\n    height: 100%;\n    display: flex;\n    flex-direction: column;\n}\n\n.addClient_scrollWrap{\n    display: flex;\n    flex-direction: column;\n    overflow-y: auto;\n    flex-grow: 1;\n}\n\n.addClient_inputs{\n    display: flex;\n    flex-wrap: wrap;\n    --formGap: 10px;\n    gap: 0px var(--formGap);\n    align-items: flex-end;\n}\n\n.addClient_schedule{\n    width: 100%;\n}\n\n.addClient_schedule_label{\n    font-weight: 400;\n    font-size: calc(12px * var(--fontScaler));\n    line-height: 150%;\n\n    color: #3B4256;\n    margin-bottom: 16px;\n}\n\n.addClient_schedule_content{\n    display: flex;\n    gap: 21px;\n    flex-wrap: wrap;\n}\n\n.addClient_firstName{\n    width: calc(40% - var(--formGap) / 2);\n}\n\n.addClient_lastName{\n    width: calc(60% - var(--formGap) / 2);\n}\n\n.addClient_dateOfBirth{\n    width: calc(65% - var(--formGap) / 2);\n    display: flex;\n    gap: var(--formGap);\n\n    align-items: flex-end;\n}\n\n.addClient_email{\n    width: calc(35% - var(--formGap) / 2);\n}\n\n.addClient_notes{\n    width: 100%;\n    margin-top: 10px;\n}\n\n.addClient_buttons{\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    margin-top: 20px;\n}\n\n.addClient_buttons_right{\n    display: flex;\n    gap: 26px;\n}\n\n.addClient_save{\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    padding: 10px 40px;\n    background: #FFA825;\n    border-radius: 24px;\n    font-weight: 500;\n    font-size: calc(13px * var(--fontScaler));\n    line-height: 23px;\n    text-align: center;\n    text-transform: uppercase;\n    color: #FFFFFF;\n}\n\n.addClient_delete{\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    padding: 10px 40px;\n    background: #E23424;\n    border-radius: 24px;\n    font-weight: 500;\n    font-size: calc(13px * var(--fontScaler));\n    line-height: 23px;\n    text-align: center;\n    text-transform: uppercase;\n    color: #FFFFFF;\n}\n\n.addClient_icon{\n    width: 22px;\n    height: 22px;\n    border: none;\n    background-repeat: no-repeat;\n    background-position: center;\n    background-size: contain;\n}\n\n.addClient_close_icon{\n    width: 17px;\n    height: 17px;\n    background-image: url(\"../../../../assets/close.svg\");\n}\n\n.dropDownCalendar_labelBox{\n    width: 100%;\n    margin-bottom: 14px;\n}\n\n.dropDownCalendar_dropDown{\n    width: 100%;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
